module.exports = __webpack_public_path__ + "img/img_4639.7673a0b2.jpg";